export default {"src":"/_next/static/media/expand.3d761586.svg","height":24,"width":24};